import { useEcommApp } from '@jane/shared/providers';

import { EmbeddedCartDrawer } from './embeddedCartDrawer';
import { MarketplaceCartDrawer } from './marketplaceCartDrawer';

export const PendingCartDrawer = ({
  container,
}: {
  container?: string | HTMLElement;
}) => {
  const { isIframe } = useEcommApp();

  if (isIframe) return <EmbeddedCartDrawer container={container} />;

  return <MarketplaceCartDrawer container={container} />;
};
